import { FC } from 'react';
import { PageWrapper } from '@/components/ui';

interface InternalDashboardErrorProps {
    error: string;
    onRetry: () => void;
}

export const InternalDashboardError: FC<InternalDashboardErrorProps> = ({ error, onRetry }) => (
    <PageWrapper title="Analytics" hideHeader containerClassName="p-0 bg-neutral-50 min-h-screen">
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center bg-white p-8 border border-neutral-200">
                <p className="text-neutral-500 text-sm mb-3">{error || 'Unable to load data'}</p>
                <button onClick={onRetry} className="text-sm text-neutral-700 underline hover:text-neutral-900">Retry</button>
            </div>
        </div>
    </PageWrapper>
);
